import { render, screen } from "@testing-library/react";
import Button from "./Button";

test("check rendering button", () => {
  render(<Button title="Test Button" />);
  expect(screen.getByText("Test Button")).toBeInTheDocument();
});
